var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-row',[_c('base-col',{attrs:{"cols":"4"}},[_c('base-typography',{attrs:{"value":"代理申請者:","single":""}})],1),_c('base-col',{attrs:{"cols":"8"}},[_c('base-typography',{attrs:{"value":_vm.name,"single":"","large":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }